<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>

<template>
  <div class="relative w-full h-screen flex items-center justify-start">
    <!-- Image as the background with <img> tag -->
    <img
      src="@/../img/home/home-screen.jpg"
      alt="Background"
      class="absolute w-full h-full object-cover rounded-lg shadow-lg"
    />

    <!-- Black Overlay covering full screen -->
    <div class="absolute inset-0 bg-black bg-opacity-80"></div>

    <!-- Content Box (Left-Aligned & Full Height) -->
    <div class="section-container">
      <div
        class="relative z-10 flex flex-col justify-center items-start w-full text-left text-white h-full px-10"
      >
        <h1
          class="text-4xl md:text-5xl text-white"
        >{{ $t('Zorgblik Uitzendbureau en Bemiddeling') }}</h1>
        <p
          class="mt-5 text-xl font-semibold text-white"
        >{{ $t('Samen bouwen aan zorg die werkt.') }}</p>
        <p class="mt-5 text-lg font-semibold text-white">{{ $t('Onze Belofte') }}</p>
        <div
          class="mt-5 text-lg text-white"
        >{{ $t('Zorg gaat verder dan het oplossen van acute problemen. Bij Zorgblik staat continuïteit centraal. Wij bouwen aan een constructieve samenwerking, zodat we vandaag én morgen de zorg kunnen leveren die uw organisatie nodig heeft.') }}</div>
      </div>
    </div>
  </div>
</template>
